








import { Component, Vue } from "vue-property-decorator";
import FormularioChapuzon2026 from "@/components/Formularios/Chapuzon2026/FormularioChapuzon2026.vue";

@Component({
  components: {
    FormularioChapuzon2026
  },
  meta: {
    // sets document title
    title: "Chapuzón del Estrecho 2026 - Ilustre Municipalidad de Punta Arenas",
    // optional; sets final title as "Index Page - My Website", useful for multiple level meta
    //titleTemplate: title => `${title} - My Website`,

    // meta tags
    meta: {
      description: {
        name: "description",
        content: "Ilustre Municipalidad de Punta Arenas"
      },
      keywords: { name: "keywords", content: "Punta Arenas" },
      equiv: {
        "http-equiv": "Content-Type",
        content: "text/html; charset=UTF-8"
      }
    }
  }
})
export default class CarnavalView extends Vue {
  private mounted() {
    document.title =
      "Chapuzón del Estrecho 2026 - Ilustre Municipalidad de Punta Arenas";
  }
}
